export default [
    {
      path: '/notifications',
      name: 'notifications',
      component: () => import('../../views/notifications/notifications.vue'),
      meta: {
        pageTitle: 'Notifications',
        breadcrumbs: ['Notifications'],
      },
      children:[
        {
          path: '',
          name: 'notifications-scheduling',
          component: () => import('../../views/notifications/scheduling/list.vue'),
          meta: {
            pageTitle: 'Notification Scheduling',
            breadcrumbs: ['Notifications', 'Scheduling'],
          }
        },
        {
          path: 'general',
          name: 'notifications-list',
          component: () => import('../../views/notifications/general/list.vue')
        },
        {
          path: 'sponsored',
          name: 'sponsored-notifications-list',
          component: () => import('../../views/notifications/sponsored/list.vue')
        },
        {
          path: 'templates',
          name: 'notifications-templates',
          component: () => import('../../views/notifications/templates/list.vue'),
          meta: {
            pageTitle: 'Notification Templates',
            breadcrumbs: ['Notifications', 'Templates'],
          }
        },
        {
          path: 'create',
          name: 'notifications-create',
          component: () => import('../../views/notifications/create.vue'),
          meta: {
            pageTitle: 'Create Notifications',
            breadcrumbs: ['Notifications', 'Create'],
          }
        },
        {
          path: ':id/edit',
          name: 'notifications-edit',
          component: () => import('../../views/notifications/edit.vue'),
          meta: {
            pageTitle: 'Edit Notifications',
            breadcrumbs: ['Notifications', 'Edit'],
          }
        }
      ]
    }
  ]
  